import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PanelService } from 'src/app/modules/shared/services/api/panel.service';
import { OrderDetailComponent } from '../order-detail/order-detail.component';

@Component({
  selector: 'app-payment-dialog',
  templateUrl: './payment-dialog.component.html',
  styleUrls: ['./payment-dialog.component.scss']
})
export class PaymentDialogComponent implements OnInit {
  cardPinInput = new FormControl('', [Validators.required]);

  constructor(
    public dialogRef: MatDialogRef<OrderDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private panelService: PanelService
  ) { }

  ngOnInit(): void {
  }

  submitForm() {
    if (!this.cardPinInput.valid) {
      return
    }

    this.panelService.hiPinPayment(this.data?.order?.id, { pin: this.cardPinInput.value }).subscribe(res => {
      this.dialogRef.close({
        success: true
      });
    })
  }

}
